module.exports = __webpack_public_path__ + "img/brush-blueD.69b4d180.png";